/**
 * @file The AdHoc component.
 * @author Maarten Lensink
*/
import * as tslib_1 from "tslib";
import { DomainService } from '../../domain.service';
import { DialogService } from '../../core/dialog.service';
import { AlertsService } from '../../core/alerts.service';
import { TranslateService } from '@ngx-translate/core';
import { ListBase } from '../../base/list/list.base';
import { OverlayProvider } from '../../ui/overlay-provider';
import { OverlayService } from '../../core/overlay.service';
import { LocalStorageService } from '../../core/local-storage.service';
import { EventsService } from '../../core/event.service';
import { UserService } from '../../user.service';
import { Router } from '@angular/router';
import { ActionService } from '../../core/action.service';
var AdHocComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AdHocComponent, _super);
    function AdHocComponent(userService, domainService, dialogService, alertsService, translateService, router, overlayProvider, overlayService, localStorageService, eventsService, actionService) {
        var _this = _super.call(this, userService, domainService, dialogService, alertsService, translateService, router, overlayService, localStorageService, eventsService, actionService) || this;
        _this.overlayService = overlayService;
        _this.overlayMode = true;
        _this.configuration = overlayProvider.configuration;
        return _this;
    }
    AdHocComponent.prototype.select = function (item) {
        this.overlayService.closeOverlay(item);
    };
    return AdHocComponent;
}(ListBase));
export { AdHocComponent };
